import React from 'react';
import Table from '../../component/table/table'
import { BASE_END_POINT } from '../../urls'
import axios from 'axios'
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import { MDBContainer, MDBRow, MDBCol, MDBBtn } from "mdbreact";
import './project.css'
import { message } from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import { NavLink, withRouter, Redirect } from 'react-router-dom'
import { ChangeLanguage } from '../../redux/actions/LanguageAction'
import PaginationButtons from '../../component/pagenation/pagenation';
import { CSVLink } from 'react-csv';


class project extends React.Component {

  state = {
    projects: [],
    projects2: [],
    loading: true,
    refresh: false,
    page: 1,
    pages: 1,
    salesReport: [],
    financialReport: []
  }

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
    this.getProjects(1, false)
    this.getSalesReport()
    this.getFinancialReport()

  }


  getProjects = (page, refresh) => {
    this.setState({ loading: true })
    axios.get(`${BASE_END_POINT}projects?limit=20&page=${page}`, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log("projects   ", response.data)
        let data = response.data.data.map(item => [
          item.id,
          item.name_en,
          item.name_ar,
          item.tag,
          "action"])
        console.log("DATA   ", data)
        this.setState({
          loading: false,
          refresh: false,
          projects: response.data.data,
          projects2: data,
          page: response.data.page,
          pages: response.data.pageCount,
        })
      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
        this.setState({ loading: false, })
      })
  }
  getSalesReport = () => {
    axios.get(`${BASE_END_POINT}projects/salesReport/get`, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        const apiData = response.data.data || [];
        const arabicOrder = ["الأول", "الثاني", "الثالث", "الرابع", "الخامس", "السادس", "السابع", "الثامن", "التاسع", "العاشر", "الحادي عشر", "الثاني عشر"];
        const salesReport = apiData.map(project => {
          const row = {
            "المشروع": project.project,
            "قيمة المشروع": project.totalPrice,
            "عدد المبيعات": project.totalDealsCount,
            "اجمالى المباع": `${project.totalProjectDeals}%`,
            "نسبه المباع": project.totalProjectDealsRatio
          };

          project.reports.forEach((rep, i) => {
            const order = arabicOrder[i] || `${i + 1}`;
            const monthName = new Date(rep.monthDate).toLocaleString("ar-EG", { month: "long" });

            row[`الشهر ${order}`] = monthName ? monthName : "---";
            row[`نسبة الشهر ${order}`] = rep.ratio ? `${rep.ratio}%` : "---";
            row[`المتوقع للشهر ${order}`] = rep.target ? rep.target : "---";
            row[`عدد المباع للشهر ${order}`] = rep.dealsCount ? rep.dealsCount : "---";
            row[`المباع للشهر ${order}`] = rep.totalDeals ? rep.totalDeals : "0";
            row[`نسبه المباع للشهر ${order}`] = rep.totalDealsRatio ? `${rep.totalDealsRatio}%` : "0";
          });

          return row;
        });

        console.log("CSV Data Preview:", salesReport);
        this.setState({ salesReport });
      })
      .catch(error => {
        console.error("Error fetching report:", error.response);
        this.setState({ loading: false });
      });
  };
  getFinancialReport = () => {
    axios.get(`${BASE_END_POINT}projects/financialReport/get`, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        const apiData = response.data.data || [];
        const financialReport = apiData.map(val => {
          const row = {
            "المشروع": val.project.name_ar,
            'اجمالى المبالغ المحصله': val.totalCollected,
            'اجمالى الوحدات المحصله': val.collectedCount,
            'اجمالى المبالغ الغير محصله': val.totalNotCollected,
            'اجمالى الوحدات الغير محصله': val.notCollectedCount
          };
          return row;
        });

        console.log("CSV Data Preview:", financialReport);
        this.setState({ financialReport });
      })
      .catch(error => {
        console.error("Error fetching report:", error.response);
        this.setState({ loading: false });
      });
  };

  delete = (id) => {
    console.log("ID   ", id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}projects/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("ROW DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.getProjects(this.state.page)
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }

  addNewRecordButton = () => (
    <div style={{ width: '100%' }}>
      <NavLink to="Addproject">
        <Fab
          style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', float: 'left', margin: '50px 30px', width: '150px', height: '40px', borderRadius: '8px' }}
          letiant="extended"
          size="medium"
          color="primary"
          aria-label="add"
        >
          <AddIcon />{allStrings.addNewRecored}
        </Fab>
      </NavLink>
    </div>
  )

  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('PROJECTS')) return <Redirect to='/Home' />
    let canSeeReport = true;
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('PROJECT-REPORTS')) {
      canSeeReport = false
    }
    return (
      <div className="App">

        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <div className="screenTable">
                <Table
                  settings={
                    <div>
                      {canSeeReport &&
                        <CSVLink
                          data={this.state.salesReport}
                          // headers={headers}
                          filename={`مبيعات المشاريع.csv`}
                          style={{ position: 'relative', top: '-46px', display: 'inline-block' }}
                        >
                          <MDBBtn
                            color="primary"
                            style={{ borderRadius: '8px', margin: '0 30px', padding: '10px', width: '120px', background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}
                            rounded
                            className="btn-block z-depth-1a"
                          >
                            {allStrings.downloadSalesReport}
                          </MDBBtn>
                        </CSVLink>
                      }
                      {canSeeReport &&
                        <CSVLink
                          data={this.state.financialReport}
                          // headers={headers}
                          filename={`تحصيلات المشاريع.csv`}
                          style={{ position: 'relative', top: '-46px', display: 'inline-block' }}
                        >
                          <MDBBtn
                            color="primary"
                            style={{ borderRadius: '8px', margin: '0', padding: '10px', width: '155px', background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}
                            rounded
                            className="btn-block z-depth-1a"
                          >
                            {allStrings.downloadFinancialReport}
                          </MDBBtn>
                        </CSVLink>
                      }
                    </div>

                  }
                  title={allStrings.projects}
                  icon='spa'
                  data={this.state.projects}
                  data2={this.state.projects2}
                  tableColumns={["#", allStrings.englishName, allStrings.arabicName, allStrings.tag, allStrings.action]}
                  loading={this.state.loading}
                  deleteItem={(id) => { this.delete(id) }}
                  path='/projectInfo'
                  actionIndex={5}
                />
                <PaginationButtons
                  page={this.state.page}
                  pages={this.state.pages}
                  labels={allStrings}
                  onPageChange={(newPage) => {
                    this.getProjects(newPage);
                    this.setState({ page: newPage });
                  }}
                />
                {this.addNewRecordButton()}
              </div>

            </MDBCol>

          </MDBRow>
        </MDBContainer>
      </div>
    )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(project)
);

